import api from "../../core/utils/apis/api";
import jwtDecode from "jwt-decode";

const getAuthenticatedUserData = async () => {
  try {
    // const userObject = {
    //   "id" : "MDKHLCHRN",
    //   "name" : "Med Khalil Charney",
    //   "permissions" : ["access-arcanus", "add-arcanus", "update-arcanus"]
    // };
    // //const userError = { response: { data: { code: 6003, message: 'Unauthorized' } } };
    // await new Promise((resolve, reject) => setTimeout(resolve, 2000));
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      throw new Error("Access token not found");
    }
    const decodedToken = jwtDecode(accessToken);
    const userObject = await api.get(`/users/${decodedToken.id}`);
    //throw userError;
    return { data: userObject.data };
  } catch (e) {
    throw e;
  }
};

const authService = {
  getAuthenticatedUserData
};

export default authService;


// import api from "../../core/utils/apis/skillApi";
// import jwtDecode from "jwt-decode";

// const getAuthenticatedUserData = async () => {
//   try {
//     const accessToken = localStorage.getItem("accessToken");
//     const userid = localStorage.getItem("userid");

//     if (!accessToken) {
//       throw new Error("Access token not found");
//     }

//     if (!userid) {
//       throw new Error("User ID not found");
//     }

//     const decodedToken = jwtDecode(accessToken);
    
//     const userObject = await api.get(`/users/${decodedToken.userid || userid}`);
    
//     return { data: userObject.data };
//   } catch (e) {
//     throw e;
//   }
// };

// const authService = {
//   getAuthenticatedUserData
// };

// export default authService;
